import { render } from "./AddSeedStep3.vue?vue&type=template&id=b9d767f6&scoped=true"
import script from "./AddSeedStep3.vue?vue&type=script&lang=js"
export * from "./AddSeedStep3.vue?vue&type=script&lang=js"

import "./AddSeedStep3.vue?vue&type=style&index=0&id=b9d767f6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src794593303/src/git-codecommit.us-west-2.amazonaws.com/v1/repos/viracocha-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d767f6"]])

export default __exports__